import { iSettingsToken, tAvailableFTokens, tAvailableUTokens, tDiscountPercent } from "./interfaces/interfaces";

export const version: string = 'v2.0';

export const isReduxShowed: boolean = true;

export const discountPercents = [5, 10, 15] as const;
export const availableFTokens = ['USDT'] as const;
export const availableUTokens = ['BTC', 'ETH', 'BNB'] as const;

// export const basename = '/s3_2/';
// export const basename = '/s3/';
export const basename = '/dapp/';
// export const basename = '/sbd2-static/';
// export const basename = '/devnet/';
// export const basename = '/test/';

export const blockchain: 'binance' | 'chromia' = 'chromia';

export const KasUrl = 'https://dnt.techno-content.com/front_kas/';
export const projectName = 'SBD_pickaxe'
export const isProduction = false;
export const sendUserLog: boolean = true;
export const useBackendForBestChrUrl: boolean = false;

// BSC

export const apis: {[key in tDiscountPercent]: {main: string, reserve?: string}} = {
	5: {
		main: 'https://dnt.techno-content.com/sbd_tn_api_v1/'
	},
	10: {
		main: 'https://dnt.techno-content.com/sbd_tn_api_v2/'
	},
	15: {
		main: 'https://dnt.techno-content.com/sbd_tn_api_v3/'
	}
}

// CHR

// export const swapURL: null | string = null;	// mainnet
// export const swapURL: null | string = 'https://slurpyswap.com/s3/swap';	// s3
// export const swapURL: null | string = 'https://slurpyswap.com/s3_2/swap';	// s3_2
export const swapURL: null | string = 'https://slurpyswap.com/swap';	// s3_2

// export const chromiaBackendUrl = 'https://chromia.techno-content.com:10443/chromia_stats_api/';	// new pickaxe
// export const chromiaBackendUrl = 'https://chromia.techno-content.com:10443/dex_backend_chr_devnet_tn/';	// new pickaxe
export const chromiaBackendUrl = 'https://pickaxe.finance/register_chr_tn_s3/';	//s3_2
// export const chromiaBackendUrl = 'https://pickaxe.finance/register_chr_mn/';	// mainnet	(not used in s3)
// export const chromiaBackendUrl = 'https://chromia.techno-content.com:10443/dex_backend_chr_tn';	// dev net
// export const chromiaBackendUrl = 'https://chromia.techno-content.com:10443/dex_backend_chr_devnet_tn';	// dev net
// export const chromiaBackendUrl = 'https://chromia.techno-content.com:10443/dex_backend_chr_local_tn';	// local
// export const chromiaBackendUrl = 'https://chromia.techno-content.com:10443/dex_backend_tn';	// test

// export const chromiaBlockchainRID = '51E4198A9C555D5BF6F38D6340520E78E4F8DA9848F3BDE0834CDE818B3E7C3E';	// new pickaxe
export const chromiaBlockchainRID = 'DDB913FA10D9519A2DDE50D8D154F8C1A11545CE269BAAF7438F7A0E195D5DB2';	// s3_2
// export const chromiaBlockchainRID = 'AA489BA3432C686F29CC80655289219B88C24AF025711472CA736CAC25780742';	// s3
// export const chromiaBlockchainRID = 'FADAD11D04DC81171DA074E67934513F39FA6AFDF5CDFF023F981319BD5B0A47';	// mainnet
// export const chromiaBlockchainRID = 'D89421A2F660582360C1CBF3E6B22CA2B43C54B18C191021B307AD80321A3DE9';	// dev net
// export const chromiaBlockchainRID = 'D8438972C98D9BA6713E9078387F38ECE4E2DBD303870E4E65F160C41A71F63A';	// local
// export const chromiaBlockchainRID = 'E86C0E9EBB8D10A697EAD7DB8AC3C531C72C57C79977DD9044377EAA17C125BE';	// test

/* export const chromiaBlockchainUrl = [	// new pickaxe
	// "http://chromia.techno-content.com:7740"
	"https://chromia.techno-content.com:10443"
] */
export const chromiaBlockchainUrl = [	// s3_2
	"https://ovh13.techno-content.com:10443"
]
/* export const chromiaBlockchainUrl = [	// s3
	"https://chromia.techno-content.com:10443/bc"
] */
/* export const chromiaBlockchainUrl = [	// mainnet
	"https://dapps0.chromaway.com",
	"https://chromia-mainnet.w3coins.io:7740",
	"https://mainnet-dapp1.sunube.net:7740",
	"https://chromia.01node.com:7740",
	"https://chromia-mainnet.caliber.build:443",
	"https://chromia.nocturnallabs.org:7740",
	"https://chromina-node.stablelab.xyz:7740",
] */
/* export const chromiaBlockchainUrl = [	// quest
	// "https://dapps0.chromaway.com",
	"https://chromia-mainnet.w3coins.io:7740",
	"https://mainnet-dapp1.sunube.net:7740",
	"https://chromia.01node.com:7740",
	"https://chromia-mainnet.caliber.build:443",
	"https://chromia.nocturnallabs.org:7740",
	"https://chromina-node.stablelab.xyz:7740",
] */
/* export const chromiaBlockchainUrl = [	// dev
	"https://node4.devnet1.chromia.dev:7740",
	"https://node5.devnet1.chromia.dev:7740",
	"https://node6.devnet1.chromia.dev:7740"
	// "https://node7.devnet1.chromia.dev:7740",
]; */
/* export const chromiaBlockchainUrl = [	// local
	"http://chromia.techno-content.com:7741",
	// "https://chromia.techno-content.com:10443/bc_2/",
] */
/* export const chromiaBlockchainUrl = [	// test
	"https://chromia.techno-content.com:10443/bc/"
] */

export const backendForBestChrUrl = "https://ovh14.techno-content.com/node_load_balancer/node-full";

export const monitorUrl: string = 'https://pickaxe.finance/monitor_s3';	// s3_2

// export const itemIds: Object & {[key in tAvailableFTokens]: {[key in tAvailableUTokens]: {[key in tDiscountPercent]: string}}} = {	// test
/* export const itemIds: {[key in tAvailableFTokens]: {[key in tAvailableUTokens]: {[key in tDiscountPercent]: string}}} = {	// test
	'USDT': {
		'BTC': {
			5: '814f4190866379fdfdddb5b99386921d24d724677c1ecf5b300de5b889899e47',
			10: '518ab272d3a1c2abc96c3ffd4f07a58a76bb5632f8385a9b73425fb5ae35e430',
			15: 'f7c34e7bd0c7b1c1f645b2f978193f69507e03ada87d93b569c9c59713ed469d'
		},
		'ETH': {
			5: '7a93f7cb294158df49179ac386c4c682557fa9183a5b97f28cd0188881b7566c',
			10: '9f6480500875c4d0005a1c388ce93206139139c488d7342578f09728ca313a29',
			15: 'b8ca5e31db806cc3b56b8f5333ee708bebde8467e1e4273d89c6368a22c0290d'
		},
		'BNB': {
			5: '396f7a44fa60dd529f92468fab31a6bb00d810b37e08b7c257bd87347d14f2d4',
			10: '2e5852b60a20fb25270ede9b4e89791ac4a9f8c71e5464449df960b494a05ba4',
			15: '79b09362fc7a8976aa6e5044f9afead8201711c27330e4e01d91718da80fde09'
		}
	}
} */
/* export const itemIds: {[key in tAvailableFTokens]: {[key in tAvailableUTokens]: {[key in tDiscountPercent]: string}}} = {	// mainnet
	'USDT': {
		'BTC': {
			5: "2b5a6f887d1d75daa39c72e5f0c95b33db1791d3016dee3e6c9ed2a8bb6d5f49",
			10: "0f4accdc353cd6e704574e08dd1f475348cbe418a7322bb9db1e11be2ea9824f",
			15: "f042657128b3942a01cc644c489d4ce26855abbb66fde7d5d044b99bf067e435"
		},
		'ETH': {
			5: "4a5b2eeb8d3b6d1a4ec233405b5da49a7614f2c6a5ae037d3554615f2a3f548d",
			10: "5fe03eb8766668a2d748f3a2d7fd358fe707c3e8684caca7c717e10f3fe1dfa8",
			15: "ffb1215e0f23fe72c64d00624d84f5cda3bd6e29def3cf36a2544578034c8904"
		},
		'BNB': {
			5: "041a4035ffc26240bf34a2bc927509f543f1abfe1a0167537904ca65dd998d0e",
			10: "c2715bed061fcd028f93b180c001eab3b87258a715c65320e8eb3c7ee3b92758",
			15: "fc3e628eb65c6bb2a14db4ab033064224bccd2e00c5f7381452156d1f22d4f2a"
		}
	}
} */
/* export const itemIds: {[key in tAvailableFTokens]: {[key in tAvailableUTokens]: {[key in tDiscountPercent]: string}}} = {	// s3
	'USDT': {
		'BTC': {
			5: "b85ecaa1057d85835cae070c73e166ee5b62af467f0cd6e57003bbd411b60e7a",
			10: "fec7546bca8a264ed444693f4e9d88c60988e14de0ee5702803b0876e16f2d3b",
			15: "786620f270578848d86412cf24932a869ab98ed59d306736617b71350ce16e16"
		},
		'ETH': {
			5: "ebad59bd0c99a4a66afc39e9cc37713d430f77c30e8df1167de27fff4e75fea3",
			10: "4553196156f86fa134146902d08e910c03f697ebfbd5fe883cdbdce905c47705",
			15: "16de71edd008ceeabe1d9dcfbac21852cbfbfc245137c6bf42e1740db8bc316b"
		},
		'BNB': {
			5: "2f463f278003a69e5e564456e737124002d0800b21580f5aa0020f0f2b53e6d4",
			10: "2ba66197b3ad07030c86d2b5acb19482f29ce28001b55c5f1a52d6b4dafd972b",
			15: "97ce5c5f8859b783237edd455ec3cd2b413fa32b9dd34d53a26f36a2e859a082"
		}
	}
} */
/* export const itemIds: {[key in tAvailableFTokens]: {[key in tAvailableUTokens]: {[key in tDiscountPercent]: string}}} = {	// s3_2 old
	'USDT': {
		'BTC': {
			5: "e878d84eb2cf28b080b1139099e6ccc06d487c4d3f9e7a0164bd4ba0439a6b46",
			10: "52470c47eec781dd174e908e579d3672e2c893792930f52265025ff2db00e633",
			15: "ce834b9b7f711786b06db0e6dd1c6c037e02ebb6fd79bf4e7ede998342429600"
		},
		'ETH': {
			5: "51f718f28b6c30ddbd59ac9a08dec7f0e7d55613838e98851c05fa4a71c325fb",
			10: "a249d3737bba79354b855b45da98aca8235ae37012d8ebbc37ed1217eb301c21",
			15: "6f2172b64b3333371a1027d6c41af0895c765132ad0f51b650f6e562561a7fe9"
		},
		'BNB': {
			5: "d8334701f7aeb9c93d23b2b58c063d97b6dfb9a192f06e8d183e21f497d45f93",
			10: "7563da49a5b20cb1c83a222d5d90c6a8530ce0fc45880ba7a1b12ad092688e01",
			15: "76982e328a9b75b6542a05bfb3bbac3a40bebbbbb4b98006c329b0cabad30ca5"
		}
	}
} */
export const itemIds: {[key in tAvailableFTokens]: {[key in tAvailableUTokens]: {[key in tDiscountPercent]: string}}} = {	// s3_2
	'USDT': {
		'BTC': {
			5: "59dfe75bdf4fe435659c0777f1d9c603203ebe76beb81255e7650d046a20caac",
			10: "59fcd5b26ab348ba02bc6eb96e38218b622c5b4f2d3a4e6645a42c6c97605195",
			15: "dca9af0167d0dd47732f63a692ceb6ef8d6c2c199939d281ff599b8516d845a3"
		},
		'ETH': {
			5: "5605bb832c209b71d6c80aa9cb044fcfc7634db0ecc5b97796ed33da9c4db052",
			10: "5e808f17422e3a9472827aebb03552610ed10e0f13849e801a0610d82b850255",
			15: "74c78bf3fc4a009a47d8e990eaba053d9d447a61cc1ac1fc263e8160b5b755c7"
		},
		'BNB': {
			5: "454a1b1f7635b0c315f3eab3ff488c6d8ac5520f1a3a259b2b12b11d9ca77527",
			10: "366005ed55a6b312715e8d352f180bc49c679a9c3ede463bda818248c4960038",
			15: "d3ce9e40abc63597dbfab6fa187d3b3ab2781213661654c0ec6f88d08f7e1785"
		}
	}
}
/* export const itemIds: {[key in tAvailableFTokens]: {[key in tAvailableUTokens]: {[key in tDiscountPercent]: string}}} = {	// pickaxe new
	'USDT': {
		'BTC': {
			5: "be65c58b91a1b48d9a9013cc76dcc722003bd6bec96afa649cca3275aac4cebe",
			10: "5f1b8f313dbd3a1c9aa640bfc2177e81c2d99f81098d3c0a429e61afaff5b3ca",
			15: "729cd950cfe9bfff9150710096fd13b4048beee59bb4cc388c985c857282a75f"
		},
		'ETH': {
			5: "596dea05e594810aef1ad3771d2a2a6275ad327576002f00197acf6761711369",
			10: "e67ecc4ff6962edb91c05d8ccbb811787e5274b17bb1bdd5d5c2bc95e20bc6c7",
			15: "5cdaa27447a8f60d1a5474c03ba33cee8ad62cd6de0b060d1e2aa59a6a3c76b1"
		},
		'BNB': {
			5: "eba7736b1213f4894dda1446d54661f8858f40e9d99f078c0617ae098000e17f",
			10: "aafdc0fd7c43b57a02d057814666147be4f6547cddbdb91a642c8587888f7c36",
			15: "edd27339ebbf018274886aa85a192dd0ae85fd467c8f16a36b77dbeb103a71bb"
		}
	}
} */

/* export const itemIds: {[key in tDiscountPercent]: string} = {	// quest
	// v1
	// 5: '788eb239f92a6f28c39040b5630f72fbedcf5ae1ac32f63932e3d82cc4d8cdd6',
	// 10: 'c9fdaedde90902fd5b2bf774b942a33f6ae12407ff429a42d9b1f83e24c6a283',
	// 15: '8ee745dfdda89d08d57428f050db158a2c51a89e416615458534f5289a4909e0',

	// v2
	5: '3177f3ffb48d38ce565772637169007a926d28cafdafcb3c7a64ee0385adcfb1',
	10: '40230fb8974e75d9f6ab2f8e6daa89a4b9ebaeec454f835a4fe2e0bb37cdbf3a',
	15: 'eebcee2ac545ec3ad31171a3ab9b22b35b2f337d915c0ce9897923e9a4807c6b',
} */
/* export const itemIds: {[key in tDiscountPercent]: string} = {	// local
	// v2
	5: '9452899d711bec099e292d9585f9579d2eccaec5171d2f414600f2320217f303',
	10: '1d3d911d4af7548ff0eb941291d726681d43cd2eeaa6ba662c581db11f498abb',
	15: 'abcc134281b3074b95c7b53309704f993e3bc14e4dfc3fca9b67c6ad767c9e99',
} */
/* export const itemIds: {[key in tDiscountPercent]: string} = {	// test
	5: '814f4190866379fdfdddb5b99386921d24d724677c1ecf5b300de5b889899e47',
	10: '518ab272d3a1c2abc96c3ffd4f07a58a76bb5632f8385a9b73425fb5ae35e430',
	15: 'f7c34e7bd0c7b1c1f645b2f978193f69507e03ada87d93b569c9c59713ed469d',
} */
/* export const itemIds: {[key in tDiscountPercent]: string} = {	// devnet
	// v2
	5: 'd2db13aed21f08ef23739f730eda24d12e1a42e938b18a92b9f68bbf9651fd90',
	10: '2c59a839cead6a6bb58e997aaa94ead70c77c36edc207e5a2f230cb13cda5a3f',
	15: '7da97c10ccca30f51e88661d54ea8715f005d201400c6f1e5bb2338f34b264aa',
} */

/* export const fTokens: {[key in tDiscountPercent]: iSettingsToken} = {	// quest
	5: {
		name: 'USDT',
		id: 'ced37689d626e1238f7f9f750ce80e3f4a863aef2b4f7316e30ea6f2f8f57765',
		showDecimals: 2,
	},
	10: {
		name: 'USDT',
		id: 'ced37689d626e1238f7f9f750ce80e3f4a863aef2b4f7316e30ea6f2f8f57765',
		showDecimals: 2,
	},
	15: {
		name: 'USDT',
		id: 'ced37689d626e1238f7f9f750ce80e3f4a863aef2b4f7316e30ea6f2f8f57765',
		showDecimals: 2,
	},
} */
/* export const fTokens: {[key in tDiscountPercent]: iSettingsToken} = {	// devnet
	5: {
		name: 'USDT',
		id: '68b881190655daa622e59bfbfc7b33af0700cd72a60a2dba8fb674ce01dac060',
		showDecimals: 2,
	},
	10: {
		name: 'USDT',
		id: '68b881190655daa622e59bfbfc7b33af0700cd72a60a2dba8fb674ce01dac060',
		showDecimals: 2,
	},
	15: {
		name: 'USDT',
		id: '68b881190655daa622e59bfbfc7b33af0700cd72a60a2dba8fb674ce01dac060',
		showDecimals: 2,
	},
} */
/* export const fTokens: {[key in tDiscountPercent]: iSettingsToken} = {	// local
	5: {
		name: 'USDT',
		id: 'a8f34e038357c843eb4e87f8debb8c880125eb4e801bbaccc4279fca74102f7f',
		showDecimals: 2,
	},
	10: {
		name: 'USDT',
		id: 'a8f34e038357c843eb4e87f8debb8c880125eb4e801bbaccc4279fca74102f7f',
		showDecimals: 2,
	},
	15: {
		name: 'USDT',
		id: 'a8f34e038357c843eb4e87f8debb8c880125eb4e801bbaccc4279fca74102f7f',
		showDecimals: 2,
	},
} */
/* export const fTokens: {[key in tDiscountPercent]: iSettingsFToken} = {	// test
	5: {
		name: 'USDT',
		id: 'efb1800647d4f7fb4150995e45b877061db5508c32bb855b1d5c5ddd8919c776',
		showDecimals: 2,
	},
	10: {
		name: 'USDT',
		id: 'efb1800647d4f7fb4150995e45b877061db5508c32bb855b1d5c5ddd8919c776',
		showDecimals: 2,
	},
	15: {
		name: 'USDT',
		id: 'efb1800647d4f7fb4150995e45b877061db5508c32bb855b1d5c5ddd8919c776',
		showDecimals: 2,
	},
} */
/* export const fTokens: {[key in tAvailableFTokens]: iSettingsToken} = {	// mainnet
	'USDT': {
		// name: 'USDT',
		// id: 'efb1800647d4f7fb4150995e45b877061db5508c32bb855b1d5c5ddd8919c776',	// test
		id: '24a750d9f962d7d989b2c05fe3e570e106e16c030871bcb056ac5ca4a6acf77a',	// quest
		showDecimals: 2,
	},
} */
/* export const fTokens: {[key in tAvailableFTokens]: iSettingsToken} = {	// s3
	'USDT': {
		id: '464b18c12cbaba17d4307bf2f6320188c3106d3ebf6397be2732a6a2b887343c',
		showDecimals: 2,
	},
} */
export const fTokens: {[key in tAvailableFTokens]: iSettingsToken} = {	// s3_2
	'USDT': {
		id: 'f752d406934c94aa7437fffc763db138b5619e9b73f2388a5128dac2d837dfc5',
		showDecimals: 2,
	},
}
/* export const fTokens: {[key in tAvailableFTokens]: iSettingsToken} = {	// new pickaxe
	'USDT': {
		id: '0f3c8742effd4e79a76ee0ade632c47b763bf9c25093ea78084aefc4506229b4',
		showDecimals: 2,
	},
} */

/* export const uTokens: {[key in tDiscountPercent]: iSettingsToken} = {	// quest
	5: {
		name: 'CHR',
		id: 'fcfd49a9a472286778f7585ef6683abb8d752f6aa1554c3535423f35fc0844b1',
		showDecimals: 6,
	},
	10: {
		name: 'CHR',
		id: 'fcfd49a9a472286778f7585ef6683abb8d752f6aa1554c3535423f35fc0844b1',
		showDecimals: 6,
	},
	15: {
		name: 'CHR',
		id: 'fcfd49a9a472286778f7585ef6683abb8d752f6aa1554c3535423f35fc0844b1',
		showDecimals: 6,
	},
} */
/* export const uTokens: {[key in tDiscountPercent]: iSettingsToken} = {	// devnet
	5: {
		name: 'CHR',
		id: '00b339fa218304bd9f92621c6f09f0f0988a2ed20c55e8fe602a1299c4e70a7d',
		showDecimals: 6,
	},
	10: {
		name: 'CHR',
		id: '00b339fa218304bd9f92621c6f09f0f0988a2ed20c55e8fe602a1299c4e70a7d',
		showDecimals: 6,
	},
	15: {
		name: 'CHR',
		id: '00b339fa218304bd9f92621c6f09f0f0988a2ed20c55e8fe602a1299c4e70a7d',
		showDecimals: 6,
	},
} */
/* export const uTokens: {[key in tDiscountPercent]: iSettingsToken} = {	// local
	5: {
		name: 'CHR',
		id: '0edcc76eb105e18079a6f11b86c78ff59e7e3aaab598f85c762f59eb24d8b96a',
		showDecimals: 6,
	},
	10: {
		name: 'CHR',
		id: '0edcc76eb105e18079a6f11b86c78ff59e7e3aaab598f85c762f59eb24d8b96a',
		showDecimals: 6,
	},
	15: {
		name: 'CHR',
		id: '0edcc76eb105e18079a6f11b86c78ff59e7e3aaab598f85c762f59eb24d8b96a',
		showDecimals: 6,
	},
} */
/* export const uTokens: {[key in tDiscountPercent]: iSettingsUToken} = {	// test
	5: {
		// name: 'CHR',
		name: 'BTC',
		id: '7f220d9cff01bea14cde14d49b77bcb664417c18838e43501fb7b8014b9da6fc',
		showDecimals: 6,
	},
	10: {
		// name: 'CHR',
		name: 'BTC',
		id: '7f220d9cff01bea14cde14d49b77bcb664417c18838e43501fb7b8014b9da6fc',
		showDecimals: 6,
	},
	15: {
		// name: 'CHR',
		name: 'BTC',
		id: '7f220d9cff01bea14cde14d49b77bcb664417c18838e43501fb7b8014b9da6fc',
		showDecimals: 6,
	},
} */
/* export const uTokens: {[key in tAvailableUTokens]: iSettingsToken} = {	// mainnet
	'BTC': {
		// name: 'BTC',
		// id: '7f220d9cff01bea14cde14d49b77bcb664417c18838e43501fb7b8014b9da6fc',	// test
		id: '436c58be826fa8106422034d721bdb3da05152476145b43d5259ec6436ced90a',	// test
		showDecimals: 6,
	},
	'ETH': {
		// name: 'ETH',
		// id: '819325049ffc6b2cf0f3896c43c207c1e0da066b7a4ea798d07c69fa1ddd6c8e',
		id: '4a4c06c904ad2aeb4e1c8629ecbe4a227f6b4be529d2c7c97b6ed1b857b450f2',
		showDecimals: 3,
	},
	'BNB': {
		// name: 'BNB',
		// id: '4fdc1081189951b40e7b72bfe651af7a685ce8ca891f4c077d59c409d5f72d71',
		id: 'e14c3359d5ffc268d32b46b5ee9e982cbaa63e6cdf8a5d39b59a590181a785f6',
		showDecimals: 3,
	}
} */
/* export const uTokens: {[key in tAvailableUTokens]: iSettingsToken} = {	// s3
	'BTC': {
		id: 'f735d1e04f8a4f0b938cfb6045fd508bfdf6ca868819c9b45ab0533c6fd40e7b',	// test
		showDecimals: 6,
	},
	'ETH': {
		id: '06d4c90a450da654d7abb14cce08ca70f0587e82101bca3ab0c5faa0ee1ec929',
		showDecimals: 3,
	},
	'BNB': {
		id: '6bc9c5c1e304361f962a9520793486693e533d274cdfb4ebb8d45a01799380ab',
		showDecimals: 3,
	}
} */
export const uTokens: {[key in tAvailableUTokens]: iSettingsToken} = {	// s3_2
	'BTC': {
		id: '2645a0b485c26ef58521f8e224e78462d5cb7423e3b07764c8804d73db6c325c',
		showDecimals: 6,
	},
	'ETH': {
		id: '9a3ae0f0ff98fbcc132de6f97d469efaf32ecf093f8d669d2c5d1a7df776b3eb',
		showDecimals: 3,
	},
	'BNB': {
		id: '772473a401a8c2e28fee46aa072300246df1890a1af24b6b785d6387f713705c',
		showDecimals: 3,
	}
}
/* export const uTokens: {[key in tAvailableUTokens]: iSettingsToken} = {	// new pickaxe
	'BTC': {
		id: "a22c4b6298ae430ba42b18d041c49b58d48eab7a8d02c09750157faf54d60eea",
		showDecimals: 6,
	},
	'ETH': {
		id: "321b5ab452399dedcfd23fbdfab639f7879fd1ad6741f473dbcad5c80ea34220",
		showDecimals: 3,
	},
	'BNB': {
		id: "234f3adce6f21d239814564ed326441f15a150ed614140a09d77fe70e0b11cb2",
		showDecimals: 3,
	}
} */

export const APRs: {[key in tAvailableFTokens]: {[key in tAvailableUTokens]: {[key in tDiscountPercent]: string}}} = {	// quest
	'USDT': {
		'BTC': {
			5: '31',
			10: '23',
			15: '15',
		},
		'ETH': {
			5: '33',
			10: '26',
			15: '18',
		},
		'BNB': {
			5: '35',
			10: '27',
			15: '19',
		},
	}
}